import axios from "axios";
import store from "@/store";

const instance = axios.create({
  baseURL: process.env.VUE_APP_API_URL,
  headers: {},
  timeout: 100000
});

// Add a request interceptor
instance.interceptors.request.use(
  function(config) {
    // Do something before request is sent.

    const conferenceId = store.getters.conferenceId;

    if (config.method === "get" && config.params == null) {
      config.params = new URLSearchParams("limit=200");
    } else if (config.method === "get") {
      config.params.append("limit", "200");
    }

    if (conferenceId != null) {
      config.params.append("conference", conferenceId);
    }

    return config;
  },
  function(error) {
    // Do something with request error
    return Promise.reject(error);
  }
);

// Add a response interceptor
instance.interceptors.response.use(
  function({ data: resData }) {
    // Any status code that lie within the range of 2xx cause this function to trigger
    // Do something with response data
    const { data } = resData;

    return data;
  },
  function(error) {
    if (error.response) {
      console.log(error);
      store.dispatch("alert/open", {
        title: "網路錯誤",
        message: error.message,
        type: "error"
      });
    }
    return Promise.reject(error);
  }
);

export default instance;
